// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2v79J","insightsList":"newBusinessInsightsMenu_insightsList__2ZtpH","active":"newBusinessInsightsMenu_active__CDsKj"};